import { optimizeMultilineText } from '../textUtils';
import { drawSegments } from './segments';
import { DrawTextArgs } from './types';

/**
 * Either draw text segments or text shapes, depending on the object structure
 */
export const drawText = (opts: DrawTextArgs) => {
  const {
    className,
    group,
    maxRows = Infinity,
    maxWidth,
    segmentConfig = {},
    startX,
    startY = 0,
    text = '',
    style = {},
    ...args
  } = opts || {};
  const { segments } = segmentConfig;

  if (segments && segments.length > 0) {
    const initialX = startX || style.x || 0;

    drawSegments({
      group,
      className,
      startX: initialX,
      startY,
      style,
      maxWidth,
      ...args,
      ...segmentConfig,
    });
  } else {
    group.addShape('text', {
      name: className,
      className,
      draggable: true,
      attrs: {
        text: Number.isFinite(maxWidth)
          ? optimizeMultilineText(text, { maxWidth, maxRows, fontConfig: style })
          : text,
        x: startX ?? 0,
        y: startY,
        ...style,
      },
    });
  }
  return group;
};

/**
 * Update either draw text segments or text shapes, depending on the object structure
 */
export const updateText = ({ group, ...args }: DrawTextArgs) => {
  group.clear();
  drawText({ group, ...args });
};
